import KeyErase from '../../atoms/container/keyEraseContainer';
import VirtualKeyboardContext from '../../../../shared/components/utils/context/virtualKeyboardContext';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';
import { useAppSelector } from '../../../../shared/store/hooks';
import { useContext, useState } from 'react';
import EraseIcon from '@components/atoms/icons/erase';
import KeyEraseIconContainer from '@components/atoms/container/keyEraseIconContainer';

function EraseKey({
  index,
  alternateKeyboard,
}: {
  index: number[];
  alternateKeyboard?: boolean;
}) {
  const { enabled } = useAppSelector(magicRemoteSelector);
  const { listIndex, listFocused, onClick } = useContext(
    VirtualKeyboardContext
  );
  const [hovered, setHovered] = useState(false);
  const focused = !enabled && listFocused && index.includes(listIndex);
  return (
    <KeyErase
      onClick={() => index.length && onClick(index[0])}
      onPointerEnter={() => setHovered(true)}
      onPointerLeave={() => setHovered(focused)}
      focused={hovered || focused}
      alternateKeyboard={alternateKeyboard}
    >
      <KeyEraseIconContainer alternateKeyboard={alternateKeyboard}>
        <EraseIcon focused={hovered || focused} />
      </KeyEraseIconContainer>
    </KeyErase>
  );
}

export default EraseKey;
